import { Button, Dropdown, Empty, Modal, message } from "antd";
import StarIcon from "../../../assets/star-icon.png";
import { CaretDownFilled } from "@ant-design/icons";
import { useEffect, useState } from "react";
import {
  GetServiceProviderReviews,
  UpdateServiceProviderReviews,
} from "../../../utils/api";
import Loader from "../../shared/Loader";
import { imgPath } from "../../../utils/axiosInstance";
import { commonDateFormat } from "../../../utils/helper";

const Reviews = ({ id, startDate, endDate }) => {
  const [modalData, setModalData] = useState({
    visible: false,
    selectedStatus: null,
    review: null,
  });
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const dropdownItems = [
    {
      label: "Published",
      key: 0,
      disabled: false,
    },
    {
      label: "Unpublished",
      key: 2,
      disabled: false,
    },
  ];

  const getReviews = async (params) => {
    setLoading(true);
    if (id) {
      try {
        const res = await GetServiceProviderReviews(id, params);
        if (res?.isSuccess) {
          setReviews(res?.items);
          setLoading(false);
        } else {
          setLoading(false);
          message.error("Error while fetching detials, Please try again");
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      setLoading(true);
      message.error("Error while fetching detials, Please try again");
    }
  };

  const handleActionModalOpen = (action, status, review) => {
    if (action === "changeStatus") {
      setModalData({ visible: true, selectedStatus: status, review: review });
    }
  };

  const handleChangeStatusOk = async () => {
    try {
      setBtnLoading(true);
      const res = await UpdateServiceProviderReviews(
        { status: modalData?.selectedStatus },
        modalData?.review?.id
      );
      setBtnLoading(false);
      if (res?.isSuccess) {
        message.success("Status updated successfully");
        getReviews();
        setModalData({ visible: false, selectedStatus: null, review: null });
      }
    } catch (error) {
      setBtnLoading(false);
      message.error("Error in updating status, Try again later");
    }
  };

  const handleModalCancel = () => {
    setModalData({ visible: false, selectedStatus: null, review: null });
  };

  useEffect(() => {
    let params = "";
    if (startDate !== null && endDate !== null) {
      params = "filter=custom";
      params += `&startDate=${startDate}&endDate=${endDate}`;
    }
    getReviews(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  if (loading) {
    return <Loader height="h-16" margin="my-16" />;
  }

  return (
    <div className="w-full flex flex-col gap-y-2">
      <div>
        {reviews &&
          reviews?.length > 0 &&
          reviews?.map((review) => {
            return (
              <div
                key={review?.id}
                className="w-full flex flex-col border-bottom gap-y-2 py-2 px-4 poppins"
              >
                <div className="flex justify-between items-center">
                  <div className="flex gap-x-3">
                    <img
                      className="w-10 h-10 rounded-full"
                      src={`${imgPath}${review?.business_Profile?.image}`}
                      alt="img"
                    />
                    <div className="flex flex-col w-full">
                      <span className="font-medium text-sm">
                        {review?.user?.name}
                      </span>
                      <div className="flex items-center gap-x-2">
                        <img src={StarIcon} width={16} alt="star-icon" />
                        <span className="text-lightGray text-sm">
                          {review?.rating}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center flex-col 2xl:flex-row gap-x-2 gap-y-1">
                    <div className="text-right">
                      <span className="text-[11px] 2xl:text-xs text-lightGray">
                        {commonDateFormat(review?.created_At)}
                      </span>
                    </div>
                    <div
                      className={`${
                        review.status === 0
                          ? "text-[#54a43a] bg-[#f0f7ed]"
                          : "text-yellow-900 bg-yellow-300"
                      } capitalize border flex items-center gap-x-1 py-1 px-2 text-sm rounded-lg cursor-pointer`}
                    >
                      <Dropdown
                        menu={{
                          items: dropdownItems.filter(
                            (item) => item.key !== review?.status
                          ),
                          onClick: (e) =>
                            handleActionModalOpen(
                              "changeStatus",
                              e?.key,
                              review
                            ),
                        }}
                        trigger={["click"]}
                      >
                        <div className="flex items-center gap-x-1">
                          <span className="text-xs">
                            {review?.status === 0
                              ? "Published"
                              : "Unpublished" || "--"}
                          </span>
                          <button className="text-[10px]">
                            <CaretDownFilled />
                          </button>
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                </div>
                <div className="w-[85%]">
                  <p className="text-[13px] text-lightGray font-normal">
                    {review?.comment}
                  </p>
                </div>
              </div>
            );
          })}
        {reviews && reviews?.length === 0 && (
          <div className="w-full text-center my-16 font-medium text-xl">
            <Empty description="No data found yet!" />
          </div>
        )}
      </div>

      <Modal
        centered
        title="Confirm Status Change"
        open={modalData.visible}
        onOk={handleChangeStatusOk}
        onCancel={handleModalCancel}
        footer={
          <div>
            <Button onClick={handleModalCancel}>Cancel</Button>
            <Button
              type="primary"
              className="text-white"
              onClick={handleChangeStatusOk}
            >
              Ok
              {btnLoading && (
                <span className="loader ml-2 align-middle mb-1"></span>
              )}
            </Button>
          </div>
        }
      >
        {`Are you sure you want to change the status to ${
          parseInt(modalData.selectedStatus) === 0 ? "published" : "unpublished"
        }?`}
      </Modal>
    </div>
  );
};

export default Reviews;
